export function playAudio(src) {
    let audio = new Audio(src);

    let isiOS = /iP(ad|hone)/i.test(navigator.userAgent);
    if(isiOS) {
        audioTouchInit(audio);
    } else {
        audio.play();
    }
}

function audioTouchInit(audio) {
    let touchListener = forceSafariPlayAudio(audio);

    audio.addEventListener('play', function() {
        window.removeEventListener('touchstart', touchListener, false);
    }, false);

    window.addEventListener('touchstart', touchListener, false);
}

const forceSafariPlayAudio = audio => () => {
    audio.load(); // iOS 9
    audio.volume = 0.5;
    audio.play(); // iOS 7/8
}




// WEBPACK FOOTER //
// ./src/audio/utils.js